import classNames from 'classnames';
import { ThemePrimary, ThemeText, ThemeBackground } from '../../context/theme/ThemeConstantsUpdated';
import { useTheme } from '../../context/theme/useTheme';
import { FooterColumn } from './FooterColumn';
import { navigation, socials } from './constants';
import { Link } from 'react-router-dom';

const { borderBackground, mainBackground } = ThemeBackground;
const { tertiaryText, secondaryText } = ThemeText;
const { primaryText, primaryShadow, primaryTextHover, primaryBackgroundIntense, primaryBackgroundMuted } = ThemePrimary;

export const Footer = ({ isVibrant }: { isVibrant?: boolean }) => {
  const { isDarkMode } = useTheme();

  return (
    <footer
      className={classNames(
        primaryShadow,
        isVibrant ? (isDarkMode ? primaryBackgroundMuted : primaryBackgroundIntense) : mainBackground,
        !isVibrant && [borderBackground, 'border-t'],
        'relative z-10 w-full'
      )}
      aria-labelledby="footer-heading"
    >
      <h2 id="footer-heading" className="sr-only">
        Footer
      </h2>
      <div className="mx-auto max-w-7xl px-12 pb-8 pt-8 lg:pt-16">
        <div className="lg:grid lg:grid-cols-3 lg:gap-8">
          <div className="mb-8 mt-16 grid grid-cols-2 gap-8 lg:col-span-2 lg:mt-0">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <FooterColumn isVibrant={isVibrant} column={navigation[0]} />
              <FooterColumn isVibrant={isVibrant} className="mt-10 md:mt-0" column={navigation[1]} />
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <FooterColumn isVibrant={isVibrant} column={navigation[2]} />
              <FooterColumn isVibrant={isVibrant} className="mt-10 md:mt-0" column={navigation[3]} />
            </div>
          </div>
          <div className="pt-8 text-center md:pt-0">
            {/* <img className="h-8 w-auto mx-auto mb-3" src={`https://tailwindui.com/img/logos/mark.svg?color=${color}&shade=600`} alt="" /> */}
            <div className="mb-5">
              <span className={classNames(isVibrant ? 'text-white' : secondaryText, 'mb-2 block text-sm leading-6')}>
                Designed, developed, and deployed by:
              </span>
              <h2
                className={classNames(
                  isVibrant ? 'text-white' : primaryText,
                  'block font-mono text-2xl font-bold leading-8'
                )}
              >
                CODY the CODER
              </h2>
            </div>
            <div className="flex justify-center space-x-6 align-middle">
              {socials.map((item) => (
                <a
                  key={item.name}
                  href={item.link}
                  className={classNames(isVibrant ? 'text-gray-100' : tertiaryText, primaryTextHover)}
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-6 w-6" aria-hidden="true" />
                </a>
              ))}
            </div>
            <div className="pt-5">
              <p
                className={classNames(
                  isVibrant ? 'text-gray-100' : tertiaryText,
                  primaryTextHover,
                  'text-xs leading-5'
                )}
              >
                &copy; 2026 Cody Snyder, All rights reserved.
              </p>
            </div>
            <div>
              <p className={classNames(tertiaryText, 'text-center text-xs leading-relaxed')}>
                <Link to="/terms" className={classNames(tertiaryText, primaryTextHover, 'font-semibold')}>
                  Terms of Service
                </Link>{' '}
                and{' '}
                <Link to="/privacy" className={classNames(tertiaryText, primaryTextHover, 'font-semibold')}>
                  Privacy Policy
                </Link>
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
